import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Combo } from 'src/app/digigov/models/combo.model';
import { Response } from 'src/app/digigov/models/response.model';
@Injectable({
  providedIn: 'root',
})
export class RemarksActionService {
  constructor(private http: HttpClient) {}
  getCombo(data): Observable<Response<Combo[]>> {
    return this.http.post<Response<Combo[]>>('/worklist/get-combo-list', data);
  }
  getInboxCorrData(postData) {
    return this.http.post('/worklist/inbox-daks', postData);
  }
  createTaggedAction(dataForPost) {
    return this.http.post('/common/remark-action', dataForPost);
  }
  //get populate Form Data from remarkAction
  getPopulateFormData(remarkActionId) {
    let params = new HttpParams();
    params = params.append('remarkActionId', remarkActionId);
    return this.http.get('/common/remark-action', {
      params: params,
    });
  }
  //get populate Form Data from corrID
  getPopulateFormDataCorrID(corrId) {
    let params = new HttpParams();
    params = params.append('corrId', corrId);
    return this.http.get('/common/remark-action', {
      params: params,
    });
  }
  //Get Reciever Count Details
  getReceiverCountWidget() {
    return this.http.get('/common/remark-action-receiver-count-dtls');
  }
  //Receiver Tagged Action Dynamic Grid Data
  getGridDataforRTaggedAction() {
    return this.http.get('/common/remark-action-receiver-tracking-dtls');
  }
  getGridDataforRTaggedActionAll(status) {
    let params = new HttpParams();
    params = params.append('status', status);
    return this.http.get('/common/remark-action-receiver-tracking-dtls', {
      params: params,
    });
  }

  //Get SO Tagged Count Details
  getSOTaggedCountWidget() {
    return this.http.get('/common/remark-action-count-dtls');
  }
  //SO Tagged Action Dynamic Grid Data
  getGridDataforSOTaggedActionTotal(assignType) {
    let params = new HttpParams();

    params = params.append('assignType', assignType);
    return this.http.get('/common/remark-action-tracking-dtls', {
      params: params,
    });
  }
  getGridDataforSOTaggedActionAll(assignType, state) {
    let params = new HttpParams();
    params = params.append('assignType', assignType);
    params = params.append('status', state);
    return this.http.get('/common/remark-action-tracking-dtls', {
      params: params,
    });
  }
}
